import {MappedRedirectInterface, MatchesFn} from '@/src/ports/services/mapped-redirect'
import qs from 'qs'

export class MobileMappedRedirect implements MappedRedirectInterface {
  matches: Map<RegExp, MatchesFn>

  constructor(matches: Map<RegExp, MatchesFn>) {
    this.matches = matches
  }

  do(pathname: string): string | undefined {
    for (const [regex, matchFn] of this.matches.entries()) {
      const matches = pathname.match(regex)
      if (matches) {
        return matchFn(pathname, matches)
      }
    }
  }
}

/**
 * Правила нормализации web-URL'ов под роутинг мобильного приложения (SSG: пути -> query-параметры).
 * Fallback для DeepLink'ов из внешних источников: если query-параметр уже присутствует в пути,
 * правило не матчится и URL возвращается без изменений (идемпотентно) — повторный редирект не выполняется.
 */
export const createMobileRedirectsMap = (): Map<RegExp, MatchesFn> =>
  new Map<RegExp, MatchesFn>([
    [
      /\/oauth\/(.*)\/callback/,
      (path: string, matches: RegExpMatchArray) => {
        const provider = matches[1]!

        return (
          '/oauth/callback/?' +
          new URLSearchParams({
            provider: provider,
            ...qs.parse((path.split('?')[1] ?? '') as string),
          }).toString()
        )
      },
    ],
    [/\/article\/([^/?]+)\/?/, (__, matches) => `/article/?code=${decodeURI(matches[1]!)}`],
    [/\/articles\/([^/?]+)\/?/, (__, matches) => `/articles/?slug=${decodeURI(matches[1]!)}`],
    [/\/news\/([^/?]+)\/?/, (__, matches) => `/news/?code=${decodeURI(matches[1]!)}`],
    [/\/catalog\/([^/?]+)\/?/, (__, matches) => `/catalog/?slug=${decodeURI(matches[1]!)}`],
    [/\/product\/([^/?]+)\/?/, (__, matches) => `/product/?path=${decodeURI(matches[1]!)}`],
    [/\/brands\/([^/?]+)\/?/, (__, matches) => `/brands/?slug=${decodeURI(matches[1]!)}`],
    [/(\/[^/]+\/.*)/, (__, matches) => matches[1]!],
  ])